import React from 'react';
import Navbar from '../../Components/Navbar/Navbar';
import Footer from '../../Components/Footer/Footer';
import './FacultiesPage.css';
import FEIT from "../../assets/images/FEIT.png"
import STU from "../../assets/images/STU.jpg"

const faculties = [
    {
        name: "Fakulta prevádzky a ekonomiky dopravy a spojov",
        logo: "https://sk.gaudeamus.cz/getFile/case:show/id:518436/Fakulta%20prev%C3%A1dzky.jpg",
        color: "#124E8F",
        link: "https://fpedas.uniza.sk/sk/"
    },
    {
        name: "Strojnícka fakulta",
        logo: "https://www.fstroj.uniza.sk/images/mato/logo-sjf.jpg",
        color: "#A91D36",
        link: "https://www.fstroj.uniza.sk/index.php"
    },
    {
        name: "Fakulta elektrotechniky a informačných technológií",
        logo: FEIT,
        color: "#F37429",
        link: "https://feit.uniza.sk/"
    },
    {
        name: "Stavebná fakulta",
        logo: STU,
        color: "#63A6DA",
        link: "https://svf.uniza.sk/index.php"
    },
    {
        name: "Fakulta riadenia a informatiky",
        logo: "https://lh3.googleusercontent.com/proxy/F7sgDl8MOq3QqtnCGANJYm3cyvvHgOnl39SqoG9vTM4dgl2yTuHwmYya7N3tHI8aLPb_0L-9qvLdk-8b_o59Msv_EYo",
        color: "#FFCE4E",
        link: "https://www.fri.uniza.sk/"
    },
    {
        name: "Výskumný ústav vysokohorskej biológie",
        logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0Fk8p-RXlVP_cFGp8sGqrE2pYA4KVBU1a3g&s",
        color: "#FFCE4E",
        link: "https://vuvb.uniza.sk/index.php/sk/"
    },
    {
        name: "Fakulta humanitných vied",
        logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSUt9dBSllAfRGc3BKGFbQCb64NYkYLVwmolQ&s",
        color: "#EB008B",
        link: "https://fhv.uniza.sk/web/"
    },
    {
        name: "Fakulta bezpečnostného inžinierstva",
        logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTp36oXlLh4PNKqklN3GGbqmvQYIm_rBAM6Nw&s",
        color: "#00A953",
        link: "https://fbi.uniza.sk/"
    }
];

const FacultiesPage = () => {
    return (
        <div>
            <Navbar />

            <div className="page-container">
                <h1 className="page-title">Fakulty UNIZA</h1>

                <div className="faculties-grid">
                    {faculties.map((faculty, idx) => (
                        <a key={idx} href={faculty.link} className="faculty-card" style={{ borderTop: `5px solid ${faculty.color}` }}>
                            <img src={faculty.logo} alt={faculty.name} className="faculty-logo" />
                            <h2 className="faculty-name">{faculty.name}</h2>
                        </a>
                    ))}
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default FacultiesPage;
